import React from 'react'
import injectSheet from 'react-jss'
import styles from './presentation-skeleton.styles'
import Bone from 'pobble-components/dist/bone'

const PresentationSkeleton = ({ classes }) => (
  <Bone className={classes.presentation} />
)

export default injectSheet(styles)(PresentationSkeleton)
